import React, {useContext, useEffect, useState} from 'react';
import styles from './right-nav.module.css';
import {MobileMenuContext} from "../../context/mobile-menu-context";

const RightNav = () => {



    const { isMobileMenuOpen, setIsMobileMenuOpen} = useContext(MobileMenuContext);

    const[isMobileView, setIsMobileView] = useState<boolean>(false);


    useEffect(() => {
    }, [isMobileMenuOpen, isMobileView]);

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };


    // Detect screen size (mobile vs desktop)
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768);  // Define mobile screen size breakpoint
        };

        handleResize();  // Run on mount
        window.addEventListener('resize', handleResize);  // Listen for window resize

        return () => window.removeEventListener('resize', handleResize);  // Clean up event listener on unmount
    }, []);

    return (

        <ul className={`navbar-nav ${styles.right_nav} mb-2 mb-lg-0 d-flex flex-column flex-lg-row align-items-lg-center gap-2 ms-lg-auto`}>
            <li className="nav-item">
                <a className={`${styles.nav_link} nav-link active`} aria-current="page" href="/" onClick={closeMobileMenu}>
                    Accueil
                </a>
            </li>
            <li className="nav-item">
                <a  className={`${styles.nav_link} nav-link active`} aria-current="page" href="/about" onClick={closeMobileMenu}>
                    À propos
                </a>
            </li>
            <li className="nav-item">
                <a  className={`${styles.nav_link} nav-link active`} aria-current="page" href="/Programes" onClick={closeMobileMenu}>
                    Programme
                </a>
            </li>
            {/*<li className="nav-item">*/}
            {/*    <a  className={`${styles.nav_link} nav-link active`} aria-current="page" href="/Gallerie" onClick={closeMobileMenu} >*/}
            {/*        Gallerie*/}
            {/*    </a>*/}
            {/*</li>*/}
            <li className="nav-item">
                <a  className={`${styles.nav_link} nav-link active`} aria-current="page" href="/contact" onClick={closeMobileMenu}>
                    Contact
                </a>
            </li>

        </ul>


    );
};

export default RightNav;